<template>
  <div class="loader"><span></span></div>
</template>

<script setup>
</script>

<style lang="scss" scoped>

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader {
  border: 5px solid $border; // §10 track (was grey #f3f3f3)
  border-top: 5px solid $brand-green; // U10 green spinner (was blue #3498db)
  border-radius: $radius-pill;
  animation: spin 2s linear infinite;
  &.big {
    border: 16px solid $border;
    border-top: 16px solid $brand-green;
  }
}

// §11 — respect reduced-motion
@media (prefers-reduced-motion: reduce) {
  .loader {
    animation: none;
  }
}</style>
